<template>
  <section  class="big spacer half">
    <div id="socialmedia" class="big pt pb bb bt">
      <a target="_blank" :href="contact.instagram">Instagram</a>
    </div>
    <form
      id="newsletter"
      action="https://aha-festival.us20.list-manage.com/subscribe/post?u=f61bc318c8b6d3429d69fea3b&amp;id=fe519af25c"
      method="post"
      class="validate aha-newsletter"
      target="_blank"
      novalidate
    >
      <input
        type="email"
        value=""
        name="EMAIL"
        class="email big"
        placeholder="Email für Newsletter"
        required
      />
      <!-- <button type="button" name="button">Abonnieren</button> -->
      <div style="position: absolute; left: -5000px;" aria-hidden="true">
        <input
          type="text"
          name="b_f61bc318c8b6d3429d69fea3b_fe519af25c"
          tabindex="-1"
          value=""
        />
      </div>
      <input
        type="submit"
        :value="'→ ' + $t('subscribe')"
        name="button"
        class="button big pt"
      />
    </form>
  </section>
</template>

<script>
import API from "@/api/service";
export default {
  data() {
    return {
      contact: []
    }
  },
  created() {
    API.contact(this.$i18n.locale).then(page => {
      this.contact = page.data.result;
    });
  },
};
</script>

<style lang="scss" scoped>
input {
  border: 0;
  width: 100%;
  font-family: "PlainMedium", sans-serif;
  border: 0;
  padding: 0;
  // height: calc(6.5 * var(--fs));
  padding-top: var(--lh);
  padding-bottom: var(--lh);
  border-bottom: var(--b) solid var(--color);
  appearance: none;
  color: var(--color);
  background: transparent;
  border-radius: 0;
  &::placeholder {
    color: var(--hover);
  }
  &.button {
    border: 0;
    text-align: left;
    padding: 0;
    padding-top: var(--lh);
    // height: calc(5.5 * var(--fs));
    padding-bottom: 0;
    cursor: pointer;
    width: auto;
    border-bottom: var(--b) solid transparent;
    &:hover {
      border-bottom: var(--b) solid var(--color);
    }
    &:focus {
      outline: none;
    }
  }
  &:focus {
    outline: none;
  }
}
</style>
